// extracted by mini-css-extract-plugin
export default {"basic-select":"BasicSelect_basic-select__XazGi","control":"BasicSelect_control__w0c9c","error":"BasicSelect_error__yZROJ"};